import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WebdokuService } from '../web-doku/webdoku.service';
import { DocumentService } from '../shared/services/document.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DocumentCopyDataResolved } from '../shared/models/document-copydata-resolved';

@Injectable({
  providedIn: 'root'
})
export class DocumentCopyDataResolver {
  private webDokuService = inject(WebdokuService);
  private documentService = inject(DocumentService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DocumentCopyDataResolved> {
    const wd = route.paramMap.get('wd') ?? '';
    const docid = route.paramMap.get('docid') ?? '';

    console.log(`document history resolve for ${docid}`)

    return this.webDokuService.selectWebDoku(wd).pipe(
      switchMap((wdSelectOk) => this.getCopyData(wdSelectOk, docid))
    );
  }

  getCopyData(selectWdOk: boolean, docid: string): Observable<DocumentCopyDataResolved>{
    if (!selectWdOk) {
      return of({
        properties: undefined,
        docId: docid,
        error: new Error(`wd not selectable`)
      });
    }
    return this.documentService.getCopyData(docid)
      .pipe(
        map(copyData => ({properties: copyData, docId: docid})),
        catchError((err) => of({
          properties: undefined,
          docId: docid,
          error: err
        }))
      );
  }
}
